import { render, staticRenderFns } from "./LegalWiseJuneNZ.vue?vue&type=template&id=27ed2eb9&scoped=true"
import script from "./LegalWiseJuneNZ.vue?vue&type=script&lang=js"
export * from "./LegalWiseJuneNZ.vue?vue&type=script&lang=js"
import style0 from "./LegalWiseJuneNZ.vue?vue&type=style&index=0&id=27ed2eb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed2eb9",
  null
  
)

export default component.exports